import { BANK_TAB } from "../../framework/tab/tabUtilsConstants";

export const columnDefs = [
  {
    headerName: "Bank Id",
    field: "bankId",
    width: 120,
    hide: true,
  },
  // {
  //   headerName: "Lock",
  //   field: "lock",
  //   width: 100,
  //   // Dropdown
  // },
  {
    headerName: "Bank Name",
    field: "bankName",
    width: 120,
  },
  {
    headerName: "Short Name",
    field: "shortName",
    width: 120,
  },
  {
    headerName: "Bank Code",
    field: "bankCode",
    width: 120,
  },
  {
    headerName: "A/C No.",
    field: "accountNo",
    width: 120,
  },
  {
    headerName: "MICR Code",
    field: "micrCode",
    width: 120,
  },
  {
    headerName: "IFSC Code",
    field: "ifsc",
    width: 150,
  },

  {
    headerName: "GST Type",
    field: "gstinType",
    width: 150,
  },
  {
    headerName: "Permanent GSTIN",
    field: "gstin",
    width: 150,
  },
  {
    headerName: "Provisional GSTIN",
    field: "provisionalGstin",
    width: 150,
  },
  {
    headerName: "Branch Code",
    field: "branchCode",
    width: 120,
  },
  {
    headerName: "Description",
    field: "discription",
    width: 200,
  },
  {
    headerName: "Note",
    field: "note",
    width: 200,
  },
  {
    headerName: "Address",
    field: "bankAddress",
    width: 200,
  },
  {
    headerName: "Locality",
    field: "locality",
    width: 120,
  },
  {
    headerName: "Pin",
    field: "pincode",
    width: 120,
  },
  {
    headerName: "City",
    field: "city",
    width: 120,
  },
  {
    headerName: "Area",
    field: "area",
    width: 120,
  },
  {
    headerName: "Region",
    field: "region",
    width: 120,
  },
  {
    headerName: "Zone",
    field: "zone",
    width: 120,
  },
  {
    headerName: "Country",
    field: "country",
    width: 120,
  },
  {
    headerName: "E-Mail",
    field: "bankEmail",
    width: 150,
  },
  // {
  //   headerName: "Contact Person",
  //   field: "contactPerson",
  //   width: 150,
  //   // Numeric
  // },
];

export const columnDefsFunctions = {};

export const initial_state_banks = {
  type: BANK_TAB,
  label: "Banks",
  allowMultipleTabs: false,
};
